export enum SortEnum {
  DESCENDING = 'DESCENDING',
  ASCENDING = 'ASCENDING',
}
